<template>
  <div>
    <v-dialog v-model="dialog" max-width="900px">
      <v-card>
        <v-card-title class="blue darken-3 white--text">
          <span class="text-h5"> Sessiones de clases de este modulo. </span>
        </v-card-title>

        <v-card-text>
          <template>
            <v-expansion-panels v-model="openedPanel" class="mt-2" focusable popout>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <b>{{ formTitle }}</b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row no-gutters class="xcard mb-8" style="background:#EBEBEB">
                    <v-col cols="12" class="mb-3">
                      <v-text-field
                        v-model.trim="session.nombre_session"
                        label="* Nombre de la clase"
                        placeholder="ej: Clase 1"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="mb-3">
                      <v-text-field
                        v-model.trim="session.url"
                        label="* Link de la session"
                        placeholder="link de zoom u otra plataforma..."
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    

                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model.trim="session.ingreso"
                        label="* Fecha ingreso"
                        placeholder="ej: 19:00 10/03/1994"
                        outlined
                        :error="ingresoerr != null"
                        :error-messages="ingresoerr"
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model.trim="session.salida"
                        label="* Fecha salida"
                        placeholder="ej: 22:00 10/03/1994"
                        class="pl-2"
                        outlined
                        :error="salidaerr != null"
                        :error-messages="salidaerr"
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md=""> </v-col>
                  </v-row>

                  <p class="text-center red--text">{{ msg }}</p>
                  <v-progress-linear indeterminate v-if="loading" />

                  <v-btn color="green darken-3" class="white--text" :disabled="loading || exitoso" @click="save">
                    {{ btnText }}
                  </v-btn>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>

          <template>
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="desserts"
              :items-per-page="100"
              hide-default-footer
              :caption="' Modulo: ' + xmod.nombre"
              class="elevation-0 mt-4"
            >
              <template v-slot:[`item.options`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="orange" class="darken-4" dark v-bind="attrs" v-on="on" @click="editarclick(item)">
                      mdi-pencil
                    </v-icon>
                  </template>
                  <span>Editar {{ item.Nombre_session }} </span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="red"
                      class="darken-4 ml-4"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="preeliminarclick(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  <span>Eliminar {{ item.Nombre_session }} </span>
                </v-tooltip>
              </template>
            </v-data-table>
          </template>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-3" class="white--text" @click="dialog = !dialog">
            Cerrar
          </v-btn>
          <!-- <v-btn color="green darken-3" class="white--text" :disabled="loading || exitoso" @click="save">
            Guardar
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      loading: false,
      exitoso: false,
      msg: '',
      ingresoerr: null,
      salidaerr: null,
      openedPanel: null,
      session: {
        id: null,
        modulo_id: null,
        nombre_session: 0,
        ingreso: null,
        salida: null,
        url: null,
      },
      nits: [],
      headers: [
        { text: '#', value: 'nro' },
        { text: 'Nombre clase', value: 'Nombre_session' },
        { text: 'Link', value: 'Url' },
        { text: 'Ingreso', value: 'Ingreso' },
        { text: 'Salida', value: 'Salida' },
        { text: 'Opciones', value: 'options' },
      ],
      desserts: [],
      xmod: { nombre: '' },
    }),

    computed: {
      formTitle() {
        return this.session.id ? 'Editar Clase' : 'Click aqui para Registrar nueva clase';
      },
      btnText() {
        return this.session.id ? 'Guardar cambios' : 'Registrar';
      },
    },

    watch: {
      'session.ingreso': function() {
        let cadena = this.session.ingreso;
        let r = /^[0-9]{2}:[0-9]{2}( )[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/;
        let resultado = r.test(cadena);
        if (!resultado) this.ingresoerr = 'formato: HH:mm dd/MM/yyyy';
        else this.ingresoerr = null;
      },
      'session.salida': function() {
        let cadena = this.session.salida;
        let r = /^[0-9]{2}:[0-9]{2}( )[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/;
        let resultado = r.test(cadena);
        if (!resultado) this.salidaerr = 'formato: HH:mm dd/MM/yyyy';
        else this.salidaerr = null;
      },
    },

    methods: {
      openmodal(item) {
        //window.console.log(item);
        this.dialog = true;
        this.loading = false;
        this.exitoso = false;
        this.desserts = [];
        this.session.id = null;
        this.session.modulo_id = 0;
        this.session.nombre_session = null;
        this.session.link = null;
        this.session.ingreso = null;
        this.session.salida = null;
        this.ingresoerr = null;
        this.salidaerr = null;
        this.openedPanel = null;
        this.msg = '';
        if (item) {
          this.xmod.nombre = item.modulo.nombre;
          this.getitems(item);
        }
      },
      editarclick(item) {
        window.console.log(item);
        this.session.id = item.Id;
        this.session.nombre_session = item.Nombre_session;
        this.session.url = item.Url;
        this.session.modulo_id = item.Modulo_id;
        this.session.ingreso = item.Ingreso;
        this.session.salida = item.Salida;
        this.openedPanel = 0;
        this.exitoso = false;
        this.msg = '';
      },
      preeliminarclick(item) {
        var vue = this;
        var opt = {
          verification: 'eliminar',
          verificationHelp: 'Escriba "[+:verification]" para eliminar la session.',
          okText: 'Eliminar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'soft',
        };
        var message = {
          title: 'Confirmar Eliminacion',
          body: '<br> <b>NOTA:</b> Los datos de las asistencias en bruto permaneceran disponibles.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.eliminarclick(item, dialog);
          })
          .catch(function() {});
      },
      vallength(str, min = 0, max = 255) {
        if (!str) return true;
        if (str.length < min) return true;
        if (str.length > max) return true;
        return false;
      },
      parsefecha(f) {
        if (!f) return;
        let fs = f.split(' ');
        let hour = fs[1].split(':');
        let date = fs[0].split('-');
        return `${hour[0]}:${hour[1]} ${date[2]}/${date[1]}/${date[0]}`;
      },
      parsedatetosend(f) {
        if (!f) return;
        let fs = f.split(' ');
        let hour = fs[0].split(':');
        let date = fs[1].split('/');
        return `${date[2]}-${date[1]}-${date[0]} ${hour[0]}:${hour[1]}:00`;
      },
      getitems(item) {
        this.session.modulo_id = item.id;
        const vue = this;
        let urlc = `${process.env.VUE_APP_API_REST}/api/v1/sessiones/moduloid/${item.id}`;
        //let urlc = `http://localhost:8090/api/v1/sessiones/moduloid/${item.id}`;
        this.loading = true;
        xaxios.get(urlc).then((data) => {
          data.data.data.map((x, i) => {
            x.nro = i + 1;
            x.Ingreso = vue.parsefecha(x.Ingreso);
            x.Salida = vue.parsefecha(x.Salida);
          });
          vue.desserts = data.data.data;
          vue.loading = false;
        });
      },
      async save() {
        this.msg = '';
        if (this.ingresoerr) this.msg = 'Hora de ingreso tiene formato invalido';
        if (this.salidaerr) this.msg = 'Hora de salida tiene formato invalido';
        if (!this.session.nombre_session || this.session.nombre_session.length > 30)
        if (!this.session.url || this.session.url.length > 250)
          this.msg = 'Ingrese un nombre de la clase/session no mayor a 250 caracteres.';
        if (this.msg) return;
        this.loading = true;

        let data = {
          Modulo_id: this.session.modulo_id,
          Nombre_session: this.session.nombre_session,
          Url: this.session.url,
          Ingreso: this.parsedatetosend(this.session.ingreso),
          Salida: this.parsedatetosend(this.session.salida),
        };

        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/sessiones/asignar`;
        //const url = `http://localhost:8090/api/v1/sessiones/asignar`;
        if (this.session.id) data.id = this.session.id;

        xaxios.request({
          method: 'POST',
          url: url,
          data: data,
        })
          .then(({ data }) => {
            //window.console.log(data, vue);
            if (data.data.Id > 0) {
              vue.exitoso = true;
              vue.msg = 'Registrado.';
              vue.openedPanel = null;
              vue.getitems({ id: vue.session.modulo_id });
              vue.openmodal(null);
              vue.session.modulo_id = data.data.Modulo_id;
              vue.$emit('onsaved')
            } else vue.msg = 'No se pudo registrar.';
            vue.loading = false;
          })
          .catch((e) => {
            window.console.log(e.response.data);
            try {
              vue.msg = e.response.data.errors[0];
            } catch (e) {
              window.console.log(e);
            }
            vue.loading = false;
          });
      },
      eliminarclick(item, dialog) {
        window.console.log('ELIMIN::: ', item);
        const vue = this;
        let urlc = `${process.env.VUE_APP_API_REST}/api/v1/sessiones/eliminar/${item.Id}`;
        //let urlc = `http://localhost:8090/api/v1/sessiones/eliminar/${item.Id}`;
        this.loading = true;
        xaxios.delete(urlc).then((data) => {
          window.console.log(data.data.data);
          if (data.data.data == 'OK') {
            vue.openedPanel = null;
            vue.getitems({ id: item.Modulo_id });
          }
          vue.$emit('onsaved');
          dialog.close();
        });
      },
    },
    mounted() {},
  };
</script>
